export function isValidDate(value?: string) {
    if (value?.length !== 10) {
        return false;
    }

    const asDate = new Date(value);

    return value && !isNaN(asDate.getTime())
}